import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed29194"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（職種別） 設定", -1))
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "職種選択", -1))
const _hoisted_5 = { class: "checkbox-grid" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_9 = ["id", "aria-selected", "href", "aria-controls"]
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = ["id", "aria-labelledby"]
const _hoisted_12 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_shokushu_setting_item = _resolveComponent("shokushu-setting-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-4",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allShokushuTypes, (type) => {
            return (_openBlock(), _createElementBlock("label", {
              key: type,
              class: "checkbox-item"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                value: type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedShokushuTypes) = $event))
              }, null, 8, _hoisted_6), [
                [_vModelCheckbox, _ctx.selectedShokushuTypes]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.shokushuTypeLabels[type]), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleShokushuTabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tab.type,
              class: "nav-item"
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: index === 0 }]),
                "data-toggle": "tab",
                role: "tab",
                id: `${tab.type}-tab`,
                "aria-selected": index === 0,
                href: `#${tab.type}-panel`,
                "aria-controls": `${tab.type}-panel`
              }, _toDisplayString(tab.label), 11, _hoisted_9)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleShokushuTabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-pane fade", { 'show active': index === 0 }]),
              role: "tabpanel",
              key: tab.type,
              id: `${tab.type}-panel`,
              "aria-labelledby": `${tab.type}-tab`
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.items, (item) => {
                  return (_openBlock(), _createBlock(_component_shokushu_setting_item, {
                    key: item.item.id,
                    item: item,
                    onChangeInput: (v) => _ctx.onChangeInput(tab.items, v)
                  }, null, 8, ["item", "onChangeInput"]))
                }), 128))
              ])
            ], 10, _hoisted_11))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}